var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMedal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.875a4.375 4.375 0 100-8.75 4.375 4.375 0 000 8.75z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.998.625a6.867 6.867 0 00-4.375 12.172v5.953a.617.617 0 00.297.531.626.626 0 00.61.032l3.468-1.743 3.47 1.742c.088.04.183.061.28.063a.625.625 0 00.625-.625v-5.953A6.867 6.867 0 009.998.625zm0 12.5A5.625 5.625 0 1115.623 7.5a5.633 5.633 0 01-5.625 5.625z",
    fill: "#fff"
  })));
}

export default SvgMedal;